import Button from 'components/shared/button/button';
import styles from './componentContainer.module.scss';

const ComponentContainer = ({ data }) => {
  const {
    component,
    align,
    positionRightDesktop,
    positionRightMobile,
    positionTopDesktop,
    positionTopMobile,
  } = data;

  const getAlign = () => {
    switch (align) {
      case 'right':
        return 'flex-end';
      case 'center':
        return 'center';
      default:
        return 'flex-start';
    }
  };

  return (
    <section
      className={styles.wrapper}
      style={{
        '--align': getAlign(),
        '--position-right-desktop': `${positionRightDesktop || 0}rem`,
        '--position-right-mobile': `${positionRightMobile || 0}rem`,
        '--position-top-desktop': `${positionTopDesktop || 0}rem`,
        '--position-top-mobile': `${positionTopMobile || 0}rem`,
      }}
    >
      <div className={styles.componentWrapper}>
        {component.typeName === 'ComponentButton' && (
          <Button button={component} className={styles.button} />
        )}
      </div>
    </section>
  );
};

export default ComponentContainer;
